import React from 'react'
import { FC } from 'react'
import numeral from 'numeral'
import { DataGridCell } from '@imodules/react-components/controls/DataGridCell'

import { DesignationCell } from './DesignationCell'
import { DataGridRowProps } from './LeaderboardDataGrid'

export interface CellProps {
    displayCell: boolean,
    data: any,
    cellName: string,
    width: string
}

export const Cell: FC<CellProps> = props => (
    <>
        {props.displayCell && <DataGridCell
            className={`scoreboard-${props.cellName}-column data-grid-column`}
            widthType={{ kind: 'fixedWidth', fixedWidth: props.width }}
            isColumnHeader={false}
        > <span className={`${props.cellName}-span`}>{props.data}</span>
        </DataGridCell>}
    </>
)

export const DataGridRow: FC<DataGridRowProps> = props => {
    const { name, totalDollars, recordCount, id, percentageOfAllGifts, percentageOfAllContributers, calculatedBonus, percentageOfGoal, goalAmount } = props.data
    const { parentFormBaseUrl, parentFormId } = props.leaderboardSettings
    const { displayRank,
        displayDollarsRaised,
        displayDonors,
        rankPosition,
        designationsPosition,
        dollarsRaisedPosition,
        donorsPosition,
        appealCode,
        displayPercentageOfDollars,
        percentageOfDollarsPosition,
        displayPercentageOfParticipation,
        percentageOfParticipationPosition,
        bonusAmountPosition,
        displayBonusAmount,
        percentageOfGoalsPosition,
        displayPercentageOfGoals,
        displayGoals,
        goalsPosition,
        defaultGoals } = props.leaderboardSettings.layoutSettings
    const scoreboardTypeId = props.leaderboardSettings.scoreboardTypeId
    const columns = [
        { column: 'rank', position: rankPosition, component: <Cell key="rank" width="7%" cellName="rank" displayCell={displayRank} data={props.rank} /> },
        { column: 'designations', position: designationsPosition, component: <DesignationCell key="designation" data={name} parentFormBaseUrl={parentFormBaseUrl} parentFormId={parentFormId} designationId={id} appealCode={appealCode} /> },
        { column: 'donors', position: donorsPosition, component: <Cell key="donors" width="15%" cellName="donors" displayCell={displayDonors} data={recordCount} /> },
        { column: 'dollarsRaised', position: dollarsRaisedPosition, component: <Cell key="dollars" width="20%" cellName="dollars" displayCell={displayDollarsRaised} data={<><span className="currency-symbol-span">{imod.cms.scoreboards.verbiage.globalCurrencySymbol}</span>{numeral(totalDollars).format()}</>} /> },
        { column: 'bonusAmount', position: bonusAmountPosition, component: <Cell key="bonus" width="15%" cellName="bonus" displayCell={displayBonusAmount} data={<><span className="currency-symbol-span">{imod.cms.scoreboards.verbiage.globalCurrencySymbol}</span>{numeral(calculatedBonus).format()}</>} /> },
        { column: 'percentageOfDollars', position: percentageOfDollarsPosition, component: <Cell key="percentageDollars" width="15%" cellName="percentageDollars" displayCell={displayPercentageOfDollars && scoreboardTypeId === 13} data={<>{numeral(percentageOfAllGifts).format()}<span className="percent-symbol-span">%</span></>} /> },
        { column: 'percentageOfParticipation', position: percentageOfParticipationPosition, component: <Cell key="percentageParticipation" width="15%" cellName="percentageParticipation" displayCell={displayPercentageOfParticipation} data={<>{numeral(percentageOfAllContributers).format()}<span className="percent-symbol-span">%</span></>} /> },
        { column: 'percentageOfGoal', position: percentageOfGoalsPosition, component: <Cell key="percentageGoal" width="15%" cellName="percentageGoal" displayCell={displayPercentageOfGoals} data={<>{numeral(percentageOfGoal).format()}<span className="percent-symbol-span">%</span></>} /> },        
        {
            column: 'goalAmount',
            position: goalsPosition,
            component:
                <Cell
                    key="goals"
                    width="15%"
                    cellName="goals"
                    displayCell={displayGoals}
                    data={defaultGoals === 'Dollars' ?
                        <>
                            <span className="currency-symbol-span">{imod.cms.scoreboards.verbiage.globalCurrencySymbol}</span>
                            {numeral(goalAmount).format()}
                        </> :
                        <>
                            {numeral(goalAmount).format()}
                        </>
                    }
                />,
        },

    ]

    return (
        <ul className="data-grid-row desktop-scoreboard">
            {columns.sort((x, y) => x.position - y.position).map(x => x.component)}
        </ul >
    )
}
